import {
  FETCH_PACKAGE_LIST_FAILURE,
  FETCH_PACKAGE_LIST_SUCCESS,
  FETCH_BULLETINS_FAILURE,
  FETCH_BULLETINS_SUCCESS,
} from "../constant";

const initialState = {
  packages: {},
  packageHeader: [],
  bulletins: [],
};

const presubscription = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PACKAGE_LIST_SUCCESS:
      const packageHeader = action.payload ? Object.keys(action.payload) : [];
      return {
        ...state,
        packageHeader,
        packages: action.payload,
      };
    case FETCH_PACKAGE_LIST_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case FETCH_BULLETINS_SUCCESS:
      return {
        ...state,
        bulletins: action.payload,
      };
    case FETCH_BULLETINS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default presubscription;
